export default {
  section: {
    value: 'section',
    title: 'Раздел товаров',
  },
  product: {
    value: 'product',
    title: 'Товары',
  },
  article: {
    value: 'nothing',
    title: 'Статья не к чему не относится',
  },
}